/**
 * Pre-populate enquire form with services data.
 */
export function enquireForm() {
    const enquireForm = document.querySelector('#gform_2');

    function selectOption(fieldContainerName, optionValue) {
        const fieldContainer = enquireForm.querySelector(fieldContainerName);
        const option = fieldContainer && fieldContainer.querySelector('select option[value="' + optionValue + '"]');

        if (option) {
            option.selected = true;
        }
    }

    if (enquireForm) {
        const latestService = localStorage.getItem( 'latest-service' );
        const latestServiceType = localStorage.getItem( 'latest-service-type' );

        if (latestService) {
            selectOption('.populate-services', latestService);
        }

        if (latestServiceType) {
            selectOption('.service-types', latestServiceType);
        }
    }

    jQuery(function($) {
      $('#gform_8 input[name="input_30"]').change(function(){
        if (this.value === 'HCP') {
          $('#input_8_37').val("Home Care Package (HCP)");
        } else if(this.value === 'CHSP'){
          $('#input_8_37').val("Commonwealth Home Support Program (CHSP)");
        } else {
          $('#input_8_37').val("Not sure");
        }
      })
    });

}



// WEBPACK FOOTER //
// ./src/js/forms.js